import _ from "lodash";

const AMBIFI3D_CONFIG_KEYS = ["ambifi3d", "ambifi3D"];

export function getAmbifi3dEntityConfig(entity = {}) {
	if (!_.isPlainObject(entity)) {
		return null;
	}

	for (const key of AMBIFI3D_CONFIG_KEYS) {
		if (_.isPlainObject(entity[key])) {
			return entity[key];
		}
	}

	let authorProperties = entity.authorProperties;
	if (_.isString(authorProperties) && _.trim(authorProperties)) {
		try {
			authorProperties = JSON.parse(authorProperties);
		} catch (_err) {
			return null;
		}
	}
	if (!_.isPlainObject(authorProperties)) {
		return null;
	}

	for (const key of AMBIFI3D_CONFIG_KEYS) {
		if (_.isPlainObject(authorProperties[key])) {
			return authorProperties[key];
		}
	}
	return null;
}

export function hasAmbifi3dEntityInputChanged(currentEntity = {}, nextEntity = {}) {
	if (currentEntity === nextEntity) {
		return false;
	}
	if (!currentEntity || !nextEntity) {
		return currentEntity !== nextEntity;
	}

	const identityKeys = ["id", "entityId", "guid", "uuid", "key", "checklistId"];
	if (identityKeys.some((key) => currentEntity[key] !== nextEntity[key])) {
		return true;
	}

	if (
		currentEntity.authorProperties === nextEntity.authorProperties
		&& currentEntity.ambifi3d === nextEntity.ambifi3d
		&& currentEntity.ambifi3D === nextEntity.ambifi3D
	) {
		return false;
	}

	return !_.isEqual(getAmbifi3dEntityConfig(currentEntity), getAmbifi3dEntityConfig(nextEntity));
}
